import { useMsal, AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';
import { loginRequest } from './authConfig';
import Profile from './components/Profile.jsx';
import Landing from './components/Landing.jsx';
import AcceptInvite from './components/AcceptInvite.jsx';
import PrivacyPolicy from './components/PrivacyPolicy.jsx';
import TermsOfService from './components/TermsOfService.jsx';

export default function App() {
  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();

  // Lightweight routing: a few standalone pages live at fixed paths.
  // A handful of routes doesn't justify pulling in react-router.
  const path = window.location.pathname.replace(/\/+$/, '');
  if (path === '/accept') {
    const token = new URLSearchParams(window.location.search).get('token');
    return <AcceptInvite token={token} />;
  }
  if (path === '/privacy') return <PrivacyPolicy />;
  if (path === '/terms') return <TermsOfService />;

  const handleLogin = () => {
    instance.loginRedirect(loginRequest).catch((e) => console.error('login failed', e));
  };

  const handleLogout = () => {
    instance.logoutRedirect().catch((e) => console.error('logout failed', e));
  };

  return (
    <div className="app">
      <header className="topbar">
        <div className="brand">🦅 Eagle Ridge Outdoor Club</div>
        <AuthenticatedTemplate>
          <div className="user-chip">
            <span>{activeAccount?.name || activeAccount?.username}</span>
            <button onClick={handleLogout}>Sign out</button>
          </div>
        </AuthenticatedTemplate>
      </header>

      <main className="content">
        <UnauthenticatedTemplate>
          <Landing onLogin={handleLogin} />
        </UnauthenticatedTemplate>

        <AuthenticatedTemplate>
          <Profile />
        </AuthenticatedTemplate>
      </main>

      <footer className="footer">
        <span>Eagle Ridge Farm · Corinth, Kentucky</span>
        <span className="footer-links">
          <a href="/privacy">Privacy Policy</a>
          <span aria-hidden="true"> · </span>
          <a href="/terms">Terms of Service</a>
        </span>
      </footer>
    </div>
  );
}
